import React, { Component } from 'react'
import axios from 'axios'
import config from '@public-config'
import { compose, withBeacon } from '@hocs'
import LottieSVG from '@components/LottieSVG'
import cx from 'classnames'
import styles from './Buoy.scss'
import { imageUrl } from '@libs/appUrl'
import {
  trackFloatingIconEnterEvent,
  trackFloatingIconEnterPopBoxEvent,
} from '@libs/eventTracking/homePage'
import trim from 'lodash/trim'

class Buoy extends Component {
  static defaultProps = {
    eventTrack: () => false,
  }

  constructor(props) {
    super(props)
    this._refs = {}
    this.state = {
      time: new Date().getTime(),
      name: '',
      url: '',
      img: '',
      show: false,
      svg: true,
    }
  }

  componentDidMount() {
    const { time } = this.state
    axios
      .get(`/api/popadmin/floatingicon/booking?time=${time}`)
      .then((response) => {
        const { data: { name = '', url = '', img = '' } = {} } = response
        const show = img !== '' && name !== ''
        let newUrl = trim(url)
        if (newUrl && !newUrl.startsWith('http')) {
          newUrl = `${config.imageBaseUrl}${newUrl}`
        }
        this.setState((state) => ({ ...state, show, svg: !show, name, url: newUrl, img }))

        if (newUrl) {
          // 當 icon 展示時，推送 item_impression 事件
          window.dataLayer.push({
            event: 'item_impression',
            item: 'floaticon',
          })
        }
      })
      .catch(() => {
        this.setState((state) => ({ ...state, show: true, svg: true }))
      })
  }

  handleOnClick = (e) => {
    if (e) e.preventDefault()
    const { url = '' } = this.state

    if (url) {
      const page = window.location.pathname === '/' ? '/explore/featured' : window.location.pathname
      const isPopBox = url.includes('popbox')
      const trackFunc = isPopBox ? trackFloatingIconEnterPopBoxEvent : trackFloatingIconEnterEvent
      const currentPageUrl = window.location.origin + page
      trackFunc(currentPageUrl, url)
      if (window.RNApp && window.RNApp.webview) {
        window.RNApp.webview(url)
      } else {
        window.open(url)
      }
    }

    // 當 icon 被點擊時，推送 item_click 事件
    window.dataLayer.push({
      event: 'item_click',
      item: 'floaticon',
    })
  }

  render() {
    const { show = false, name = '', img = '', svg = false, url = '' } = this.state
    const className = cx('buoy', { svg, show: show || svg })

    if (!url) {
      return null
    }

    return (
      <div className={className} onClick={this.handleOnClick}>
        <style jsx>{styles}</style>
        {show && <img src={imageUrl(img)} alt={name} />}
        {svg && (
          <LottieSVG
            wrapClassName="popbox-container"
            className="popbox"
            loop={true}
            autoplay={true}
          />
        )}
      </div>
    )
  }
}

export default compose(withBeacon)(Buoy)
